import React from 'react';
import { Card, Title2, Body1 } from '@fluentui/react-components';
import { useStyles } from './HomePage.styles';

function SiteCard({ title, description, icon: Icon, iconColor, onClick }) {
  const classes = useStyles();

  return (
    <Card
      className={classes.siteCard}
      onClick={onClick}
    >
      <div className={classes.cardBody}>
        <div className={classes.cardHeader}>
          <Icon className={classes.cardIcon} style={iconColor ? { color: iconColor } : {}} />
          <Title2 className={classes.cardTitle}>
            {title}
          </Title2>
        </div>
        <Body1 className={classes.cardDescription}>
          {description}
        </Body1>
      </div>
    </Card>
  );
}

export default SiteCard;